import { render, staticRenderFns } from "./about-program.vue?vue&type=template&id=7bbe4aea&scoped=true"
import script from "./about-program.vue?vue&type=script&lang=ts"
export * from "./about-program.vue?vue&type=script&lang=ts"
import style0 from "./about-program.vue?vue&type=style&index=0&id=7bbe4aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbe4aea",
  null
  
)

export default component.exports